// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>3</span>&nbsp;&nbsp;I will walk with purity of heart&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;within the walls of my house.<br> </p> </div></div>";
// Exports
module.exports = code;